var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBusIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "System/Line/Bus"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union",
    d: "M18 11.5H18.5V11V8C18.5 6.61929 17.3807 5.5 16 5.5H8C6.61929 5.5 5.5 6.61929 5.5 8V11V11.5H6H18ZM5.5 17V17.5H6H18H18.5V17V13V12.5H18H6H5.5V13V17ZM18 18.5H17.5V19V20C17.5 20.2761 17.2761 20.5 17 20.5C16.7239 20.5 16.5 20.2761 16.5 20V19V18.5H16H8H7.5V19V20C7.5 20.2761 7.27614 20.5 7 20.5C6.72386 20.5 6.5 20.2761 6.5 20L6.5 19L6.5 18.5H6H5C4.72386 18.5 4.5 18.2761 4.5 18V11V10.5H4C3.72386 10.5 3.5 10.2761 3.5 10V8C3.5 7.72386 3.72386 7.5 4 7.5H4.12602H4.51362L4.61024 7.12463C4.9988 5.61495 6.36983 4.5 8 4.5H16C17.6302 4.5 19.0012 5.61495 19.3898 7.12463L19.4864 7.5H19.874H20C20.2761 7.5 20.5 7.72386 20.5 8V10C20.5 10.2761 20.2761 10.5 20 10.5H19.5V11V18C19.5 18.2761 19.2761 18.5 19 18.5H18ZM9.5 15C9.5 15.2761 9.27614 15.5 9 15.5C8.72386 15.5 8.5 15.2761 8.5 15C8.5 14.7239 8.72386 14.5 9 14.5C9.27614 14.5 9.5 14.7239 9.5 15ZM15.5 15C15.5 15.2761 15.2761 15.5 15 15.5C14.7239 15.5 14.5 15.2761 14.5 15C14.5 14.7239 14.7239 14.5 15 14.5C15.2761 14.5 15.5 14.7239 15.5 15Z",
    fill: "#00182F",
    stroke: "#00182F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusIcon);
export default __webpack_public_path__ + "static/media/bus-icon.cbd0e01ba0d5f59cf7902d385b8a28e6.svg";
export { ForwardRef as ReactComponent };